import Vue from 'vue';

const proxyVue = new Vue({
	data:
		{
			proxy: {},
			theme: 'default',
		},
	watch:
		{
			theme (val: any) {
				console.log(val);
			},
		},
});

//这里不使用Proxy是因为IE全线不支持, 未来可能会替换为Proxy方案;
let proxy: any = Object.defineProperty({}, 'entity', {
	get () {
		//定义get来访问proxyVue实例的proxy属性;
		return proxyVue.proxy;
	},
});

//因为无法使用Object.defineProperty覆盖默认的set方法. 所以我直接增加set属性函数来解决这个问题.
//但是带来的问题就是set属性函数变得可枚举了.
proxy.entity.set = function (key: string, value: any){
	let target: any = proxyVue.proxy;
	if (target[key]) {
		target[key] = value;
	} else {
		proxyVue.$set(proxyVue.proxy, key, value);
	}
	return value;
};

//再次使用Object.defineProperty将set属性函数变成不可枚举状态;
Object.defineProperty(proxy.entity, 'set', { enumerable: false });

export default proxy.entity;
